<h2 mat-dialog-title fxLayoutAlign="start center" fxLayoutGap="10px">
  @if (icon && icon !== 'mediego') {
    <mat-icon [color]="danger ? 'warn' : 'primary'">{{ icon }}</mat-icon>
  } @else {
    <img src="/assets/img/logo/logo-compact-color.svg" alt="" title="" width="32" />
  }
  <span>{{ dialogTitle }}</span>
</h2>

<mat-dialog-content>
  <ng-content></ng-content>
</mat-dialog-content>

<mat-dialog-actions align="end" fxLayoutGap="10px">
  <button mat-button [mat-dialog-close]="false" class="button-decline">{{ declineLabel }}</button>
  @if (deleteLabel) {
    <button mat-button color="warn" [mat-dialog-close]="'delete'">{{ deleteLabel }}</button>
  }
  @if (acceptLabel) {
    <button #submitButton
      mat-stroked-button
      [disabled]="!formValidation || dangerCountdown > 0"
      [mat-dialog-close]="resultData ? resultData : true"
      [color]="danger ? 'warn' : 'accent'"
      class="button-confirm">
      {{ acceptLabel }} @if (dangerCountdown > 0) {
      ({{ dangerCountdown }})
    }
  </button>
}
</mat-dialog-actions>
